import apiClient from "../../utils/interceptor"
import { ApiResponse, UserData, CreateUserParams, CreateUserResponse, UpdateUserParams, UserRoleParams, GetUserRoleParams } from "./interface";
import { API_URLS } from "../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};


// Function to get all users
export const getAllUsers = async (): Promise<ApiResponse<UserData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<UserData[]>>(
            API_URLS.USER.GET_ALL_USERS,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

// Function to create a user
export const createUser = async (
    userParams: CreateUserParams
): Promise<ApiResponse<CreateUserResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateUserResponse>>(
            API_URLS.USER.CREATE_USER,
            userParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
};

// Function to update a user
export const updateUser = async (
    userData: UpdateUserParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            `${API_URLS.USER.UPDATE_USER}`,
            userData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error);
        throw error;
    }
};

// Function to disable (delete) a user
export const deleteUser = async (
    userId: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            `${API_URLS.USER.DISABLE_USER}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { user_id: userId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error disabling user:", error);
        throw error;
    }
};

// Function to create a user role
export const createUserRole = async (
    userRoleData: UserRoleParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<null>>(
            API_URLS.USER_ROLE.CREATE_USER_ROLE,
            userRoleData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error attaching user role:", error);
        throw error;
    }
};

// Function to update a user role
export const updateUserRole = async (
    userRoleData: UserRoleParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.USER_ROLE.UPDATE_USER_ROLE,
            userRoleData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating user role:", error);
        throw error;
    }
};

export const getUserRole = async (
    userRoleData: GetUserRoleParams
): Promise<ApiResponse<string[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<string[]>>(
            API_URLS.USER_ROLE.GET_USER_ROLES, {
                params: userRoleData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching user roles:", error);
        throw error;
    }
};